<template>
  <div
    class="container flex-row-space-between h-135 bg-black z-index-11"
    :class="{
      'pt-44': !isRetract,
      'pt-20': isRetract,
      'pb-44': !isRetract,
      'pb-20': isRetract,
    }"
  >
    <img class="logo-img" src="@assets/images/logo.png" alt />
    <div class="flex-row">
      <template v-if="!isRetract">
        <div
          v-for="(item, index) in navs"
          class="mr-6 hov text-with-underline flex-row-column-center pl-16 pr-16 mr-10 pointer"
          :class="{ active: getIsActiveRouter(item) }"
          style="text-decoration: none"
          :key="'navs' + index"
          @click="handleNavClick(item)"
          @mouseenter="item.childrens ? showMenu(index) : null"
          @mouseleave="item.childrens ? closeMenu : null"
        >
          <div class="OPPO-R fs-16 white">{{ $t(item.label) }}</div>
          <img
            v-if="item.icon"
            style="transform: rotate(180deg)"
            class="w-12 h-6 ml-8"
            :src="item.icon"
            alt
          />
          <transition name="dropdown">
            <div
              v-if="showMenuIndex === index && item.childrens"
              style="min-width: 100%; white-space: nowrap"
              class="p-a l-0 t-40 bg-black flex-column pl-16 pr-10"
              @mouseenter="showMenu(index)"
              @mouseleave="closeMenu"
            >
              <div
                v-for="(child, i) in item.childrens"
                class="flex h-46"
                :key="'child' + i"
                @click.stop="showMenuIndex = -1"
              >
                <div
                  class="flex h-40 flex-column dropdown pointer"
                  style="text-decoration: none; width: 100%"
                  @click="navigateTo(child.path)"
                >
                  <span
                    class="OPPO-R fs-16 white"
                    :class="{ active: getIsActiveRouter(child) }"
                    >{{ $t(child.label) }}</span
                  >
                </div>
              </div>
            </div>
          </transition>
        </div>
      </template>
      <template v-else>
        <div
          class="w-32 h-32 radius-3 bg-brown-1 flex-column flex-all-center pointer mr-20 p-r"
          @click="isMenuVisible = !isMenuVisible"
        >
          <template v-if="!isMenuVisible">
            <div class="w-22 h-3 radius-2 bg-white-1"></div>
            <div class="w-22 h-3 radius-2 bg-white-1 mt-3"></div>
            <div class="w-22 h-3 radius-2 bg-white-1 mt-3"></div>
          </template>
          <div v-else class="x"></div>
        </div>
        <transition name="dropdown">
          <div
            v-if="isMenuVisible"
            style="min-width: 100%; white-space: nowrap"
            class="p-a l-0 t-70 bg-black flex-column pl-10 pr-10 menu-wrapper"
          >
            <div
              v-for="(menuItem, i) in navs"
              class="flex flex-items-center h-72"
              :key="'menuItem' + i"
              @click.stop="onClickMenuItem(menuItem)"
            >
              <span class="OPPO-R fs-16 white">{{ $t(menuItem.label) }}</span>
            </div>
          </div>
        </transition>
      </template>
      <div
        class="OPPO-R fs-16 white mt-4 flex-row"
        :class="{
          'ml-70': !isRetract,
          'ml-20': isRetract,
        }"
      >
        <div class="pointer" @click="onEnglish">English</div>
        <div class="mr-8 ml-8">/</div>
        <div class="pointer" @click="onChinese">中文</div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@store/index";

export default {

  name: "Navbar",
  data() {
    return {
      navs: [
        { label: "navbar.home", path: "/home", icon: "" },
        {
          label: "navbar.about",
          path: "/About",
        },
        {
          label: "navbar.newsCenter",
          path: "/newscenter",
        },
        {
          label: "navbar.ourServices",
          path: "/OurService",
          icon: require("@assets/images/triangle.png"),
          childrens: [
            { label: "navbar.Services1", path: "/OurServiceBank" },
            { label: "navbar.Services2", path: "/OurServiceFixed" },
            { label: "navbar.Services3", path: "/ourServiceDigital" },
            { label: "navbar.Services4", path: "/ourServiceAI" },
          ],
        },
        {
          label: "navbar.contactUs",
          path: "/contact",
          icon: "",
        },
      ],
      showMenuIndex: -1,
      menuTimer: null,
      isRetract: false,
      isMenuVisible: false,
    };
  },
  mounted() {
    this.updateWindowWidth(); // 初始化宽度判断
    window.addEventListener("resize", this.updateWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWindowWidth);
  },
  methods: {
    handleNavClick(item) {
      // 直接跳转到对应页面，无论是否有子菜单
      this.navigateTo(item.path);
    },
    navigateTo(path) {
      console.log("Navigating to:", path);
      this.$router.push(path);
    },
    updateWindowWidth() {
      this.isRetract = window.innerWidth < 1024;
    },
    handleTabbar(index) {
      if (this.curIndex !== index) {
        this.curIndex = index;
      }
    },
    getIsActiveRouter(item) {
      const { path } = this.$route;
      return item.path === path;
    },
    onEnglish() {
      this.$i18n.locale = "en";
      // 英文环境下buttonclicked输出true
      store.commit("updateIsEn", true);
    },
    onChinese() {
      this.$i18n.locale = "zh";
      // 中文环境下buttonclicked输出false
      store.commit("updateIsEn", false);
    },
    showMenu(index) {
      if (this.menuTimer) clearTimeout(this.menuTimer);
      this.showMenuIndex = index;
    },
    closeMenu() {
      this.menuTimer = setTimeout(() => {
        this.showMenuIndex = -1;
      }, 500);
    },
    onClickMenuItem(menuItem) {
      this.$router.push(menuItem.path);
      this.isMenuVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  padding-left: 10%;
  padding-right: 10%;
  .logo-img {
    width: 25%;
    min-width: 160px;
  }
}
/* 基础文本样式 */
.text-with-underline {
  position: relative;
  color: #333;
  font-size: 18px;
  cursor: pointer;
}

/* 下划线伪元素 */
.text-with-underline::after {
  content: "";
  position: absolute;
  width: 0;
  height: 2px;
  bottom: -4px;
  right: 0; /* 初始从右侧开始 */
  background-color: white;
  transition: width 0.2s ease-out;
}

/* 鼠标移入效果 - 从右向左展开 */
.text-with-underline:hover::after {
  width: 100%;
  left: auto; /* 确保从右侧扩展到左侧 */
  right: 0;
}

/* 鼠标移出效果 - 从左向右收缩 */
.text-with-underline:not(.active):not(:hover)::after {
  transition: width 0.15s ease-in;
  width: 0;
  left: auto;
  right: 0;
}
.text-with-underline.active::after {
  width: 100%;
  left: 0;
  transition: none;
}
.dropdown {
  span {
    color: white;
  }
  &:hover {
    span {
      color: #d3b574;
    }
  }
  .active {
    color: #d3b574;
  }
}
.dropdown-enter-active {
  animation: expand-contract 0.3s ease;
}
.dropdown-leave-active {
  animation: expand-contract 0.3s ease reverse;
}
@keyframes expand-contract {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media (max-width: 1024px) {
  .container {
    padding-left: 4%;
    padding-right: 4%;
  }
  .menu-wrapper {
    border: 2px solid white;
  }
  .x {
    width: 22px;
    height: 22px;
  }
  .x::before,
  .x::after {
    content: "";
    position: absolute;
    width: 3px; /* 可以调整宽度 */
    height: 22px; /* 或者根据需要调整 */
    background-color: white; /* X的颜色 */
    border-radius: 2px;
  }
  .x::before {
    left: 46%; /* 垂直居中 */
    transform: rotate(45deg); /* 旋转45度 */
  }

  .x::after {
    left: 46%; /* 垂直居中 */
    transform: rotate(-45deg); /* 旋转-45度 */
  }
  .dropdown-enter-active {
    animation: expand-contract 0.3s ease;
  }
  .dropdown-leave-active {
    animation: expand-contract 0.3s ease reverse;
  }
  @keyframes expand-contract {
    0% {
      opacity: 0;
      height: 0;
    }
    100% {
      opacity: 1;
      height: 364px;
    }
  }
}
</style>
